import DashIcon from '@assets/icons/dash-icon.svg';
import React from 'react';
import TriangleDownIcon from '@assets/icons/triangle-down.svg';
import TriangleUpIcon from '@assets/icons/triangle-up.svg';
import { Badge, BadgeSize, BadgeVariant } from '@usepepper/ui/atoms/badge';
import { formatPercent } from '@/utils/money';
import { useTheme } from '@/contexts/theme-context';

interface GrowthPercentagePillProps {
  value: number;
}

export const GrowthPercentagePill: React.FC<GrowthPercentagePillProps> = ({
  value,
}) => {
  const theme = useTheme();

  const getRelevantIcon = () => {
    if (value > 0) {
      return (
        <TriangleUpIcon
          fill={theme.sk.color.icon.positive.secondary}
          stroke={theme.sk.color.icon.positive.secondary}
        />
      );
    } else if (value < 0) {
      return (
        <TriangleDownIcon
          fill={theme.sk.color.icon.negative.secondary}
          stroke={theme.sk.color.icon.negative.secondary}
        />
      );
    } else {
      return (
        <DashIcon
          fill={theme.sk.color.icon.primary}
          stroke={theme.sk.color.icon.primary}
        />
      );
    }
  };
  return (
    <Badge
      label={formatPercent(value).toString().replace('-', '')}
      leftElement={getRelevantIcon()}
      size={BadgeSize.XSMALL}
      variant={
        value > 0
          ? BadgeVariant.SUCCESS
          : value < 0
            ? BadgeVariant.ERROR
            : BadgeVariant.DEFAULT
      }
    />
  );
};
